<template>
    <div class="MarkingDetails">
        <!--上面部分-->
        <div class="detInfo">
            <div>
                <span>答题人：</span>
                <img :src="info.headimageurl" alt="">
                <span>{{info.customername}}</span>
            </div>
            <div>交卷时间：{{info.submittime}}</div>
            <div>用时：{{info.factexamtime}}</div>
            <div>成绩：{{info.examtotalscore}}</div>
        </div>
        <div class="detData">
            <p class="title">客观题 答题情况</p>
            <div class="detNumber">
                <div>
                    <p class="green"><b>{{info.finalrightcount}}</b>道</p>
                    <p>答对</p>
                </div>
                <div>
                    <p class="red"><b>{{info.finalfailcount}}</b>道</p>
                    <p>答错</p>
                </div>
                <div>
                    <p><b>{{info.noanswer}}</b>道</p>
                    <p>未答</p>
                </div>
                <div>
                    <p><b>{{info.noscore}}</b>分</p>
                    <p>总分</p>
                </div>
            </div>
        </div>
        <!--下面部分-->
        <div class="bottom_wrap">
            <!--客观题-->
            <el-collapse v-model="activeNames">
                <el-collapse-item title="客观题" name="1" v-if="subjectiveList.length>0">
                    <div class="subjectBox" v-for="(item,index) in subjectiveList" :key="index">
                        <div class="flex-box">
                            <span>{{index + 1}}.（{{item.questiontypename}},</span>
                            <span class="grade">分值{{item.defaultscore}}）</span>
                        </div>
                        <div v-html="item.subject"></div>
                        <baseQuse :item="item" v-if="item.questiontype!==7"></baseQuse>
                        <div class="subjectBox" v-for="(obj,index2) in item.questioninfo" :key="index2" v-if="item.questiontype==7 && obj.questiontype!=6">
                            <div class="flex-box">
                                <span>{{index + 1}}.{{index2 + 1}}.（{{obj.questiontypename}},</span>
                                <span class="grade">分值{{obj.defaultscore}}）</span>
                            </div>
                            <div v-html="obj.subject"></div>
                            <baseQuse :item="obj"></baseQuse>
                        </div>
                    </div>
                </el-collapse-item>
            </el-collapse>
            <el-collapse v-model="activeNames2" v-if="objectiveList.length>0">
                <el-collapse-item title="主观题" name="1">
                    <div v-for="(item,index) in objectiveList" :key="index">
                        <div class="subjectBox mainSubj" v-if="item.questiontype==6">
                            <div class="flex-box">
                                <span>{{index + 1}}.（{{item.questiontypename}},</span>
                                <span class="grade">分值{{item.defaultscore}}）</span>
                            </div>
                            <div v-html="item.subject"></div>
                            <objectiveQues @changeCheckmemo="changeCheckmemo" :item="item" :index="index" :objectiveList="objectiveList"></objectiveQues>
                        </div>
                        <div class="subjectBox mainSubj" v-if="item.questiontype==7">
                            <div class="flex-box">
                                <span>{{index + 1}}.（{{item.questiontypename}}）</span>
                            </div>
                            <div v-html="item.subject"></div>
                            <div class="subjectBox mainSubj" v-for="(obj,index2) in item.questioninfo" :key="index2">
                                <div class="flex-box">
                                    <span>{{index + 1}}.{{index2 + 1}}.（{{obj.questiontypename}},</span>
                                    <span class="grade">分值{{obj.defaultscore}}）</span>
                                </div>
                                <div v-html="obj.subject"></div>
                                <objectiveQues @changeCheckmemo="changeCheckmemo" :item="obj" :index="index+'-'+index2" :objectiveList="objectiveList"></objectiveQues>
                            </div>
                        </div>
                    </div>
                    <el-button  v-if="pageType==1" type="primary" @click="saveInfo()" style="margin-left: 60px">保存</el-button>
                </el-collapse-item>
            </el-collapse>
        </div>
    </div>
</template>
<script>
    import {getExamquestionInfoDetail,submitExamCheckinfo} from 'api/testPaperApi'
    import Loading from 'base/loading/loading' // 引入 loading 组件
    import {mapGetters, mapActions} from 'vuex'
    import BaseQuse from 'views/operateTool/testpaper/components/baseQuse.vue'
    import ObjectiveQues from 'views/operateTool/testpaper/components/objectiveQues.vue'
    export default {
        name: "MarkingDetails",
        data(){
            return{
                activeNames: ['1'],
                activeNames2: ['1'],
                info:{
                    questioninfolist:[{
                        userscore:'', //主观题打分
                        checkmemo:'', //评语
                    }],
                },
                pageType: this.$route.query.pageType,
                subjectiveList: [], // 客观题
                objectiveList: [] // 主观题
            }
        },
        mounted(){
            this.getDetails();
        },

        methods:{
            // 获取详情信息
            getDetails(){
                this.setLoading(true)
                getExamquestionInfoDetail({
                    data: {
                        innerid: this.$route.query.id,
                    },
                    success: data => {
                        let [list1, list2] = [[], []]
                        data.data.questioninfolist.forEach(item=>{
                            if (item.questiontype==6) {
                                if(item.userscore===0){
                                    item.userscore=''
                                }
                                list2.push(item)
                            } else{
                                if(item.questiontype==4){
                                    item.judgeValue=item.finalanswer=='T'?1:0
                                    item.userValue=item.uselanswer=='T'?1:item.uselanswer=='F'?0:''
                                    list1.push(item)
                                } else if(item.questiontype==5){
                                    this.$set(item,'uselanswer',item.uselanswer.split('|'))
                                    list1.push(item)
                                } else if(item.questiontype==7){
                                    let idx = ''
                                    let oo = {
                                        innerid: item.innerid,
                                        questiontype: item.questiontype,
                                        questiontypename: item.questiontypename,
                                        subject: item.subject,
                                        userscore:item.userscore, //得分
                                        checkmemo:item.checkmemo,
                                        questioninfo: []
                                    }
                                    item.questioninfo.forEach((obj, i) => {
                                        if(obj.questiontype==4){
                                            obj.judgeValue=obj.finalanswer=='T'?1:0
                                            obj.userValue=obj.uselanswer=='T'?1:obj.uselanswer=='F'?0:''
                                        } else if (obj.questiontype==5){
                                            this.$set(obj,'uselanswer',obj.uselanswer.split('|'))
                                        } else if (obj.questiontype==6){
                                            if(obj.userscore===0){
                                                obj.userscore=''
                                            }
                                            oo.questioninfo.push(obj)
                                            idx = i
                                        }
                                    })
                                    if (oo.questioninfo.length) {
                                        list2.push(oo)
                                    }
                                    if (idx !== '') item.questioninfo.splice(idx, 1)
                                    list1.push(item)
                                } else {
                                    list1.push(item)
                                }
                            }
                        })
                        this.subjectiveList = list1
                        this.objectiveList = list2
                        this.info=data.data
                        this.setLoading(false)
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            // 修改老师评语
            changeCheckmemo(data) {
                this.$nextTick(() => {
                    let indexList = (data.index + '').split('-')
                    if (indexList.length > 1) {
                        this.objectiveList[indexList[0]].questioninfo[indexList[1]].checkmemo = data.content
                    } else {
                        this.objectiveList[indexList[0]].checkmemo = data.content
                    }
                })
            },
            // 保存
            saveInfo(){
                let content = [],flag = true
                this.objectiveList.forEach((item,index)=>{
                    let oo = {
                        innerid:item.innerid,
                        userscore:item.userscore,
                        questiontype:item.questiontype,
                        checkmemo:item.checkmemo,
                        questioninfo: []
                    }
                    if (item.questiontype == 6) {
                        if(item.userscore===''){
                            this.$message.error('评分不能为空');
                            flag = false
                            return false
                        }else if(item.userscore>item.defaultscore){
                            this.$message.error('评分不能大于分值');
                            flag = false
                            return false
                        }
                    }
                    if (item.questiontype==7) {
                        item.questioninfo.forEach(obj => {
                            oo.questioninfo.push({
                                innerid:obj.innerid,
                                userscore:obj.userscore,
                                questiontype:obj.questiontype,
                                checkmemo:obj.checkmemo
                            })
                            if(obj.userscore===''){
                                this.$message.error('评分不能为空')
                                flag = false
                                return false
                            }else if(obj.userscore>obj.defaultscore){
                                this.$message.error('评分不能大于分值')
                                flag = false
                                return false
                            }
                        })
                    }
                    content.push(oo)
                })
                if (flag) {
                    let params={
                        examinnerid: this.$route.query.id,
                        content:JSON.stringify(content),
                    }
                    // console.log(content)
                    this._submitExamCheckinfo(params)
                }
            },
            _submitExamCheckinfo(params) {
                this.setLoading(true)
                submitExamCheckinfo({
                    data: params,
                    success: data => {
                        this.setLoading(false);
                        this.$message.success('提交成功')
                        this.$router.back()
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(data.msg)
                    }
                })
            },
            ...mapActions([
                'setLoading',
                'setPage'
            ])
        },
        computed: {
            ...mapGetters([
                'page',
            ])
        },
        components: {
            BaseQuse, ObjectiveQues
        }
    }
</script>

<style lang="scss"  type="text/scss" rel="stylesheet/scss">
    .MarkingDetails{
        line-height: 25px;
        .flex-box{
            display: flex;
            align-items: center;
        }
        .margin-10{
            margin: 15px 0;
        }
        .detInfo{
            display: flex;
            padding: 30px 0;
            align-items: center;
            div{
                padding-right: 150px;
                img{
                    width: 60px;
                    height: 60px;
                    display: inline-block;
                    vertical-align: middle;
                    border-radius: 50%;
                    margin-right: 10px;
                }
            }
        }
        .detData{
            width:100%;
            background:rgba(245,247,250,1);
            .title{
                font-size: 16px;
                color: #333;
                padding: 15px 0 10px 15px;
                font-weight: 600;
            }
            .detNumber{
                display: flex;
                justify-content: space-between;
                padding: 0 100px 30px;
                p{
                    text-align: center;
                    padding-top: 10px;
                    b{
                        font-size: 48px;
                        margin-right: 5px;
                    }
                }
                .green{
                    color: #0ABF53;
                }
                .red{
                    color: #FF4747;
                }
            }
        }
        .bottom_wrap{
            .subjectBox{
                margin-bottom: 20px;
                background:rgba(251,252,253,1);
                padding: 10px 20px;
                .subjMain{
                    display: flex;
                    flex-direction: column;
                    .writeMargin{
                        margin-top: 15px;
                    }
                    .indexNub{
                        width: 14px;
                        height: 14px;
                        line-height: 14px;
                        text-align: center;
                        border-radius: 50%;
                        border: 1px solid #999;
                        color: #999;
                        display: inline-block;
                        margin-right: 10px;
                    }
                    .hasLine{
                        width: 260px;
                        border-bottom: 1px solid #e5e5e5;
                        display: inline-block;
                    }
                    .el-icon-check{
                        color: #0ABF53;
                    }
                    .el-icon-close{
                        color: #FF4747;
                    }
                    .iconCheck{
                        position: absolute;
                        left: 0;
                    }
                    .iconWrite{
                        margin-right: 10px;
                    }
                    .rightKey{
                        color: #0ABF53;
                    }
                    .analysis{
                        color: #999;
                        margin-top: 15px;
                    }
                    /*单选竖着排列*/
                    .el-radio-group,.el-checkbox-group{
                        display: flex;
                        flex-direction: column;
                        .el-radio,.el-checkbox{
                            margin-top: 15px;
                            display: flex;
                            align-items: center;
                        }
                        /*文字颜色*/
                        .el-radio__input.is-checked+.el-radio__label,.el-radio__input.is-disabled+span.el-radio__label,
                        .el-checkbox__input.is-checked+.el-checkbox__label,.el-checkbox__input.is-disabled+span.el-checkbox__label{
                            color: #333;
                        }
                        .el-radio__input,.el-checkbox__input{
                            padding-left: 20px;
                        }
                        /*前面选框背景色*/
                        .el-radio__input.is-disabled .el-radio__inner,.el-checkbox__input.is-disabled .el-checkbox__inner{
                            background-color: #fff;
                        }
                        /*单选框选中样式*/
                        .yes .el-radio__input.is-disabled.is-checked .el-radio__inner,
                        .yes .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
                            background-color: #0ABF53;
                            border: 1px solid #0ABF53;
                        }
                        .no .el-radio__input.is-disabled.is-checked .el-radio__inner,
                        .no .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner{
                            background-color: #FF4747;
                            border: 1px solid #FF4747;
                        }
                        /*前面选框不可选时中心点颜色*/
                        .el-radio__input.is-disabled.is-checked .el-radio__inner::after{
                            background-color: #fff;
                        }
                        .el-checkbox__input.is-disabled.is-checked .el-checkbox__inner::after{
                            border-color: #fff;
                        }
                    }
                }
            }
            .mainSubj{
                .grade{
                    padding-left: 10px;
                    color: #999
                }
                .checkMemoBox{
                    display: flex;
                    p{
                        margin: 0 0;
                    }
                }
                .comment{
                    display: flex;
                    margin-top: 10px;
                }
                .el-input{
                    width: 200px;
                    margin-right: 10px
                }
                .el-button{
                    margin: 30px 40px;
                }
            }
        }
        /*折叠面板样式更改*/
        .el-collapse-item__header{
            background-color:rgba(245,247,250,1);
            text-indent: 20px;
            margin-top: 20px;
            font-size: 16px;
            font-weight: 600;
        }
        .el-collapse-item__wrap{
            border: none;
        }
    }
</style>
